import { lazy } from "react";
// Clinical Notes v2 — wizard de nota clínica asistida por IA.
const AiClinicalNotePage = lazy(() => import("./pages/AiClinicalNotePage"));
export const clinicalNotesV2Routes = [
  { path: "/clinical-notes-v2/new", element: <AiClinicalNotePage /> },
];

export { AiClinicalNotePage };
